/**
 *    @author:
 *    @since:
 *
 */

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { InputData } from '../_common/data/input-data';
import { GAData, Path } from  "../_common/constant/page-const";
import { BirthCertificateAreYouSureValidation } from './birth_certificate_are_you_sure.validator';
import { Confirm } from 'src/refresh/service/constant';

@Component({ 
      selector: 'birth_certificate_are_you_sure',
      templateUrl: './birth_certificate_are_you_sure.component.html',
      styleUrls: ['./birth_certificate_are_you_sure.component.less']
})
export class BirthCertificateAreYouSureComponent extends FormBaseComponent{


      constructor( protected router: Router ,
                   public timerService:TimerService,
                   public data:InputData ) {

            super(router, timerService,null);  
            
            super.setNextPage(Path.Transition2,Path.BirthCertificate);
            
            super.setValidator(new BirthCertificateAreYouSureValidation(this));
            ////this.clear();
      }


      public onPreviousClick() {
            super.gtag(GAData.Link,GAData.back_areYouSure);
            super.onPreviousClick();
      }

      public onNextClick() : boolean {
             this.clear();
             window.history.back();
             super.gtag(GAData.Button,GAData.continue_product);   
             return true;
      }
      
      private clear() {
            let orderOfBC = this.data.orderOfBC;
            orderOfBC.total = 0;
            orderOfBC.isReviewOtherTypeBC = "";

            orderOfBC.hasBCWithParentInfo = "";
            orderOfBC.hasBirthCertificate = "";
            orderOfBC.hasCertifiedCopyOfBR = "";

            orderOfBC.amountForBCWithParent = 0;
            orderOfBC.amountForBC = 0;
            orderOfBC.amountForCertifiedCopy = 0;

            orderOfBC.chk_BCConsent = "X";
            orderOfBC.applicantIndex = -1;
     }

}
